(function ($) {

    var DeltiZoom = function(element) {
        this.initialized = false;
        this.displaying = false;
        this.element = element;

        this.options = {
            lensBorder: 2,
            enlargedLeft: 10,
            enlargedBorder: 1,
            animationDelay: 500,
            defaultEnlargedSideLength: 500
        }
    }

    DeltiZoom.prototype.load = function(smallImage, largeImage) {
        if (!smallImage) {
            console.error('deltizoom requires a small image (src) to be set!');
            return;
        }

        if (!largeImage) {
            console.error('deltizoom requires a large image (data-zoom) to be set!');
            return;
        }

        this.smallImage = smallImage;
        this.largeImage = largeImage;
        this.initialized = false;
        this.waitForSmallImage();
    }

    DeltiZoom.prototype.init = function() {
        this.mask = $('<div>')
            .css({
                position: 'absolute',
                backgroundColor: '#fff',
                opacity: 0.5,
                zIndex: 900001
            });
        this.lens = $('<div class="j-image-gallery-lens">')
            .css({
                position: 'absolute',
                backgroundImage: 'url(' + this.smallImage + ')',
                backgroundRepeat: 'no-repeat',
                border: this.options.lensBorder + 'px solid #999',
                boxShadow: '0px 0px 10px rgba(0,0,0,0.4)',
                boxSizing: 'border-box',
                cursor: 'pointer',
                zIndex: 900002
            });
        this.enlarged = $('<div>')
            .css({
                position: 'absolute',
                backgroundImage: 'url(' + this.largeImage + ')',
                backgroundRepeat: 'no-repeat',
                border: this.options.enlargedBorder + 'px solid #333',
                boxShadow: '0px 0px 10px rgba(0,0,0,0.4)',
                zIndex: 900003
            });

        var zoom = this;

        var mouseDidSomething = function(ev) {

            var imgPosition = zoom.getSmallImagePosition();

            // get the image offset
            var relativeLeft = (ev.pageX - imgPosition.left) / imgPosition.width,
                relativeTop = (ev.pageY - imgPosition.top) / imgPosition.height;

            var mouseOutside = ( relativeLeft < 0 || relativeTop < 0 || relativeLeft > 1 || relativeTop > 1 );

            if ( !mouseOutside && ($(ev.target).hasClass("cloudzoom") || $(ev.target).hasClass("j-image-gallery-lens"))) {
                zoom.onHover(imgPosition, relativeLeft, relativeTop);
            } else {
                zoom.onStop();
            }
        }

        $(this.element).add(this.mask).add(this.lens).add(this.enlarged);
        $(document).on('mousemove', mouseDidSomething);

        this.lens.on('click', function() {
            zoom.detachNow();
            $(zoom.element).trigger('click');
        })

        this.initialized = true;
    }

    DeltiZoom.prototype.getSmallImagePosition = function() {
        var $el = $(this.element),
            offset = $el.offset();
        return {
            top: offset.top,
            left: offset.left,
            width: $el.width(),
            height: $el.height()
        };
    }

    var clampSize = function(squareSideLength, totalSize) {
        var sideLength = Math.min(squareSideLength, totalSize.width, totalSize.height);

        return { width: sideLength, height: sideLength };
    }

    var clampCenter = function(center, totalSize, viewSize) {
        var left = center.left - (viewSize.width / 2),
            top = center.top - (viewSize.height / 2);

        if ( left < 0 ) {
            left = 0;
        }
        if ( left > totalSize.width - viewSize.width ) {
            left = totalSize.width - viewSize.width;
        }
        if ( top < 0 ) {
            top = 0;
        }
        if ( top > totalSize.height - viewSize.height ) {
            top = totalSize.height - viewSize.height;
        }

        return {left: left, top: top};
    }

    DeltiZoom.prototype.calculateEnlargedSize = function() {
        this.enlargedSize = clampSize(this.options.defaultEnlargedSideLength, this.largeImageSize);
        this.zoomFactor = {
            width: this.largeImageSize.width / this.enlargedSize.width,
            height: this.largeImageSize.height / this.enlargedSize.height
        };
    }

    DeltiZoom.prototype.calculateLensSize = function(imgPosition) {
        this.lensSize = {
            width: imgPosition.width / this.zoomFactor.width,
            height: imgPosition.height / this.zoomFactor.height
        };
    }

    DeltiZoom.prototype.getLensPosition = function(imgPosition, relativeLeft, relativeTop) {
        var smallImageCenter = {
                left: imgPosition.width * relativeLeft,
                top: imgPosition.height * relativeTop
            },
            largeImageCenter = {
                left: this.largeImageSize.width * relativeLeft,
                top: this.largeImageSize.height * relativeTop
            };

        var lens = clampCenter(smallImageCenter, imgPosition, this.lensSize),
            enlarged = clampCenter(largeImageCenter, this.largeImageSize, this.enlargedSize);

        return {
            width: this.lensSize.width,
            height: this.lensSize.height,
            left: lens.left,
            top: lens.top,
            enlargedLeft: enlarged.left,
            enlargedTop: enlarged.top
        }
    }

    DeltiZoom.prototype.attach = function() {
        if ( this.displaying || !this.initialized ) {
            return;
        }

        var imgPosition = this.getSmallImagePosition();

        // position the mask
        this.mask.css({
            height: imgPosition.height + 'px',
            width: imgPosition.width + 'px',
            left: imgPosition.left + 'px',
            top: imgPosition.top + 'px'
        })

        // calculate zoom lens size
        this.calculateEnlargedSize();
        this.calculateLensSize(imgPosition); // this would move away from here when zoom is implemented

        // position the zoomed lens
        this.enlarged
            .css({
                height: '0px',
                width: '0px',
                left: (imgPosition.left + imgPosition.width / 2) + 'px',
                top: (imgPosition.top + imgPosition.height / 2) + 'px',
                opacity: 0
            })
            .stop()
            .animate({
                height: this.enlargedSize.height + 'px',
                width: this.enlargedSize.width + 'px',
                left: (imgPosition.left + imgPosition.width + this.options.enlargedLeft) + 'px',
                top: imgPosition.top + 'px',
                opacity: 1
            }, this.options.animationDelay);

        $('body').append(this.enlarged, this.mask, this.lens);
        this.displaying = true;
    }

    DeltiZoom.prototype.onHover = function(imgPosition, relativeLeft, relativeTop) {
        if ( !this.initialized ) {
            return;
        }
        if ( !this.displaying ) {
            this.attach();
        }

        var lensPosition = this.getLensPosition(imgPosition, relativeLeft, relativeTop);

        // position the lens
        this.lens.css({
            height: lensPosition.height + 'px',
            width: lensPosition.width + 'px',
            left: imgPosition.left + lensPosition.left + 'px',
            top: imgPosition.top + lensPosition.top + 'px',
            backgroundPosition:
                (-lensPosition.left - this.options.lensBorder) + 'px ' +
                (-lensPosition.top - this.options.lensBorder) + 'px',
            backgroundSize:
                imgPosition.width + 'px ' +
                imgPosition.height + 'px'
        });

        // position the large image
        this.enlarged.css({
            backgroundPosition:
                (-lensPosition.enlargedLeft) + 'px ' +
                (-lensPosition.enlargedTop) + 'px'
        })
    }

    DeltiZoom.prototype.detachNow = function() {
        if ( !this.initialized || !this.displaying ) {
            return;
        }
        this.mask.detach();
        this.lens.detach();
        this.enlarged.detach();
    }

    DeltiZoom.prototype.detach = function() {
        if ( !this.initialized || !this.displaying ) {
            return;
        }

        var imgPosition = this.getSmallImagePosition();

        this.mask.detach();
        this.lens.detach();

        this.enlarged
            .stop()
            .animate({
                height: '0px',
                width: '0px',
                left: (imgPosition.left + imgPosition.width / 2) + 'px',
                top: (imgPosition.top + imgPosition.height / 2) + 'px',
                opacity: 0
            }, this.options.animationDelay, function() {
                $(this).detach();
            });

        this.displaying = false;
    }

    DeltiZoom.prototype.onStop = function() {
        this.detach();
    }

    DeltiZoom.prototype.preloadLargeImage = function() {
        // first, set the small image size, as we now have it
        this.smallImageSize = {width: this.element.naturalWidth, height: this.element.naturalHeight};
        // once the small image has downloaded (which we want to happen FAST so we're letting it get done first), preload the large image
        var zoom = this;
        var img = new Image();
        img.onload = function() {
            zoom.largeImageSize = {width: img.width, height: img.height};
            zoom.init();
        };
        img.src = this.largeImage;
    }

    DeltiZoom.prototype.waitForSmallImage = function() {
        // verify if small image is complete: if so, continue (on a callback to avoid Zalgo), otherwise wait for it
        var zoom = this;
        if ( this.element.complete ) {
            setTimeout(function() {
                zoom.preloadLargeImage();
            }, 0);
        } else {
            $(this.element).one('load', function() {
                zoom.preloadLargeImage();
            });
        }
    }

    $.fn.deltizoom = function() {
        var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

        if ( supportsTouch ) {
            return;
        }

        $(this).each(function() {
            if ( !(this instanceof HTMLImageElement) ) {
                console.error('deltizoom must ONLY be used on img elements!', this);
                return; // which in fact means "continue", since we're in an each() call
            }

            var smallImage = $(this).attr('src'),
                largeImage = $(this).attr('data-zoom');

            var zoom;
            if ( $(this).data('deltizoom') ) {
                zoom = $(this).data('deltizoom');
            } else {
                zoom = new DeltiZoom(this);
                $(this).data('deltizoom', zoom);
            }

            zoom.load(smallImage, largeImage);
        });
    }

})(jQuery);
